{
  "_note": "REVIEW NEEDED: IRB/regulatory terminology must be reviewed by a qualified Arabic-speaking clinical research professional before activating locale=ar in production. Arabic is RTL — ensure the OV3 layout sets dir='rtl' when this locale is active.",
  "app": {
    "name": "OneVerse",
    "loading": "جارٍ التحميل...",
    "save": "حفظ",
    "cancel": "إلغاء",
    "delete": "حذف",
    "confirm": "تأكيد",
    "submit": "إرسال",
    "edit": "تعديل",
    "close": "إغلاق",
    "back": "رجوع",
    "next": "التالي",
    "search": "بحث",
    "filter": "تصفية",
    "export": "تصدير",
    "yes": "نعم",
    "no": "لا",
    "required": "مطلوب",
    "optional": "اختياري",
    "none": "لا شيء",
    "unknown": "غير معروف",
    "error": "حدث خطأ. يرجى المحاولة مرة أخرى.",
    "powered_by": "مدعوم من {{name}}"
  },
  "nav": {
    "home": "الرئيسية",
    "dashboard": "لوحة التحكم",
    "submissions": "الطلبات",
    "studies": "الدراسات",
    "sites": "المواقع",
    "users": "المستخدمون",
    "settings": "الإعدادات",
    "notifications": "الإشعارات",
    "admin": "الإدارة",
    "help": "المساعدة",
    "sign_out": "تسجيل الخروج",
    "logout": "خروج",
    "expand_sidebar": "توسيع الشريط الجانبي",
    "collapse_sidebar": "طي الشريط الجانبي"
  },
  "auth": {
    "sign_in": "تسجيل الدخول",
    "sign_in_button": "تسجيل الدخول",
    "sign_out": "تسجيل الخروج",
    "email": "البريد الإلكتروني",
    "email_placeholder": "أدخل بريدك الإلكتروني",
    "password": "كلمة المرور",
    "password_placeholder": "أدخل كلمة المرور",
    "forgot_password": "هل نسيت كلمة المرور؟",
    "reset_password": "إعادة تعيين كلمة المرور",
    "enter_reset_code": "أدخل رمز إعادة التعيين",
    "reset_code_instructions": "أدخل بريدك الإلكتروني وسنرسل لك رمزًا لإعادة تعيين كلمة المرور.",
    "new_code_instructions": "أدخل الرمز وكلمة المرور الجديدة.",
    "send_reset_code": "إرسال رمز إعادة التعيين",
    "sending": "جارٍ الإرسال...",
    "reset_password_action": "إعادة تعيين كلمة المرور",
    "resetting": "جارٍ إعادة التعيين...",
    "create_account": "إنشاء حساب",
    "welcome": "مرحبًا بك في OneVerse",
    "remember_password": "هل تتذكر كلمة المرور؟",
    "confirmation_code": "رمز التأكيد",
    "confirmation_code_placeholder": "أدخل الرمز من بريدك الإلكتروني أو رسالتك النصية",
    "new_password": "كلمة المرور الجديدة",
    "new_password_placeholder": "أدخل كلمة المرور الجديدة",
    "confirm_password": "تأكيد كلمة المرور الجديدة",
    "confirm_password_placeholder": "أكّد كلمة المرور الجديدة",
    "mfa": {
      "code": "الرمز",
      "back_to_login": "العودة إلى تسجيل الدخول",
      "sms_placeholder": "أدخل الرمز المرسل إلى هاتفك",
      "email_placeholder": "أدخل الرمز المرسل إلى بريدك الإلكتروني",
      "totp_placeholder": "أدخل الرمز من تطبيق المصادقة"
    },
    "show_password": "إظهار كلمة المرور",
    "hide_password": "إخفاء كلمة المرور",
    "errors": {
      "invalid_credentials": "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
      "account_locked": "تم قفل حسابك. يرجى التواصل مع الدعم.",
      "session_expired": "انتهت صلاحية جلستك. يرجى تسجيل الدخول مرة أخرى.",
      "email_required": "البريد الإلكتروني مطلوب",
      "email_password_required": "البريد الإلكتروني وكلمة المرور مطلوبان",
      "all_fields_required": "جميع الحقول مطلوبة",
      "passwords_dont_match": "كلمات المرور غير متطابقة",
      "unexpected": "حدث خطأ غير متوقع",
      "server_non_json": "أعاد الخادم استجابة غير JSON. تحقق من وحدة التحكم."
    },
    "welcome_back": "مرحبًا بعودتك",
    "subtitle": "يرجى إدخال بياناتك.",
    "no_account": "ليس لديك حساب؟",
    "sign_up": "إنشاء حساب"
  },
  "dashboard": {
    "welcome": "مرحبًا، {{name}}",
    "new_submission": "طلب جديد",
    "submission_overview": "نظرة عامة على الطلبات",
    "view_all_submissions": "عرض جميع الطلبات",
    "recent_activity": "النشاط الأخير",
    "no_recent_activities": "لا توجد أنشطة حديثة.",
    "search_placeholder": "بحث",
    "total": "المجموع",
    "submission_singular": "طلب",
    "submission_plural": "طلبات",
    "active_site_status": "حالة المواقع النشطة",
    "view_study": "عرض الدراسة",
    "loading_studies": "جارٍ تحميل الدراسات...",
    "select_study": "اختر دراسة",
    "view_details": "عرض التفاصيل",
    "news_and_notes": "أخبار وملاحظات",
    "no_recent_posts": "لا توجد منشورات حديثة.",
    "failed_to_load_announcements": "فشل تحميل الإعلانات",
    "statuses": {
      "response_required": "مطلوب رد",
      "drafts": "المسودات",
      "submitted": "تم التقديم",
      "pre_review": "مراجعة أولية",
      "irb_review": "مراجعة IRB",
      "post_review": "ما بعد المراجعة",
      "expiring_soon": "تنتهي قريبًا"
    }
  },
  "submissions": {
    "title": "الطلبات",
    "new": "طلب جديد",
    "empty": "لم يتم العثور على طلبات.",
    "status": {
      "pending": "معلق",
      "under_review": "قيد المراجعة",
      "approved": "موافق عليه",
      "rejected": "مرفوض",
      "revisions_required": "مطلوب تعديلات",
      "withdrawn": "مسحوب",
      "expired": "منتهي الصلاحية",
      "closed": "مغلق",
      "draft": "مسودة",
      "submitted": "تم التقديم",
      "pre_review": "مراجعة أولية",
      "irb_review": "مراجعة IRB",
      "post_review": "ما بعد المراجعة",
      "response_required": "مطلوب رد",
      "expiring_soon": "تنتهي قريبًا",
      "complete": "مكتمل",
      "deleted": "محذوف"
    },
    "fields": {
      "title": "العنوان",
      "protocol_number": "رقم البروتوكول",
      "principal_investigator": "الباحث الرئيسي",
      "submitted_at": "تاريخ الإرسال",
      "updated_at": "آخر تحديث",
      "status": "الحالة",
      "type": "النوع",
      "id": "المعرف",
      "submitted": "تاريخ التقديم",
      "expiration": "تاريخ الانتهاء"
    },
    "actions": {
      "view": "عرض الطلب",
      "edit": "تعديل الطلب",
      "withdraw": "سحب",
      "submit": "تقديم للمراجعة"
    },
    "empty_yet": "لا توجد طلبات حتى الآن.",
    "search_placeholder": "البحث بالمعرف أو العنوان",
    "filter": {
      "all_statuses": "جميع الحالات",
      "all_types": "جميع الأنواع",
      "status_label": "الحالة",
      "type_label": "النوع"
    },
    "errors": {
      "failed_to_load": "فشل تحميل الطلبات"
    }
  },
  "studies": {
    "title": "الدراسات",
    "new": "دراسة جديدة",
    "empty": "لم يتم العثور على دراسات.",
    "fields": {
      "title": "عنوان الدراسة",
      "irb_number": "رقم IRB",
      "pi": "الباحث الرئيسي",
      "status": "الحالة",
      "start_date": "تاريخ البدء",
      "end_date": "تاريخ الانتهاء",
      "id": "المعرف",
      "type": "النوع",
      "submitted": "تاريخ التقديم",
      "expiration": "تاريخ الانتهاء"
    },
    "empty_yet": "لا توجد دراسات حتى الآن.",
    "search_placeholder": "البحث بالمعرف أو العنوان",
    "filter": {
      "all_statuses": "جميع الحالات",
      "all_types": "جميع الأنواع",
      "type_label": "النوع",
      "attribute_label": "السمة",
      "all_attributes": "جميع السمات",
      "attribute_value_placeholder": "قيمة السمة"
    },
    "errors": {
      "failed_to_load": "فشل تحميل الدراسات"
    },
    "standalone": "مستقل",
    "sort_by": "الترتيب حسب {{column}}",
    "attributes": {
      "cro": "CRO",
      "sponsor": "الراعي",
      "pi": "PI",
      "pi_email": "بريد PI",
      "poc": "POC",
      "poc_email": "بريد POC",
      "poc_phone": "هاتف POC",
      "poc_role": "دور POC"
    }
  },
  "sites": {
    "title": "المواقع",
    "new": "موقع جديد",
    "empty": "لم يتم العثور على مواقع.",
    "empty_yet": "لا توجد مواقع حتى الآن.",
    "search_placeholder": "البحث بالمعرف أو اسم الموقع أو الباحث",
    "filter": {
      "all_statuses": "جميع الحالات",
      "all_countries": "جميع الدول",
      "country_label": "الدولة"
    },
    "errors": {
      "failed_to_load": "فشل تحميل المواقع"
    },
    "fields": {
      "id": "المعرف",
      "site_name": "اسم الموقع",
      "country": "الدولة",
      "protocol_number": "رقم البروتوكول",
      "sponsor_name": "اسم الراعي",
      "pi_name": "اسم الباحث الرئيسي",
      "approved": "موافق عليه",
      "expiration": "تاريخ الانتهاء",
      "status": "الحالة"
    }
  },
  "errors": {
    "not_found": "لم يتم العثور على المورد المطلوب.",
    "unauthorized": "لا تملك صلاحية تنفيذ هذا الإجراء.",
    "server_error": "حدث خطأ في الخادم. يرجى المحاولة مرة أخرى لاحقًا.",
    "network_error": "حدث خطأ في الشبكة. يرجى التحقق من اتصالك.",
    "not_found_title": "لم نتمكن من العثور على هذه الصفحة",
    "not_found_body": "الصفحة التي تبحث عنها غير موجودة أو تم نقلها.",
    "go_back": "رجوع"
  },
  "pagination": {
    "previous": "السابق",
    "next": "التالي",
    "page": "صفحة {{current}} من {{total}}",
    "showing": "عرض {{from}}–{{to}} من {{total}}"
  },
  "dates": {
    "today": "اليوم",
    "yesterday": "أمس",
    "just_now": "الآن",
    "ago": "منذ {{time}}"
  },
  "entity": {
    "status": {
      "in_progress": "قيد التنفيذ",
      "active": "نشط",
      "rejected": "مرفوض",
      "suspended": "موقوف",
      "closed": "مغلق",
      "expired": "منتهي الصلاحية"
    }
  },
  "activities": {
    "submission_approved": "تمت الموافقة على الطلب",
    "submission_created": "تم إنشاء الطلب",
    "submission_submitted": "تم تقديم الطلب",
    "submission_updated": "تم تحديث الطلب",
    "submission_withdrawn": "تم سحب الطلب",
    "submission_rejected": "تم رفض الطلب",
    "submission_expired": "انتهت صلاحية الطلب",
    "study_created": "تم إنشاء الدراسة",
    "study_updated": "تم تحديث الدراسة",
    "site_created": "تم إنشاء الموقع",
    "site_updated": "تم تحديث الموقع",
    "status_changed": "تم تغيير الحالة",
    "review_started": "بدأت المراجعة",
    "review_completed": "اكتملت المراجعة",
    "comment_added": "تمت إضافة تعليق",
    "document_uploaded": "تم رفع المستند",
    "response_required": "مطلوب الرد"
  }
}
